export interface CloudFunction {
    cloudId: string;
    cloudName: string;
    folderId: string;
    folderName: string;
    functionId: string;
    functionName: string;
}

export enum CloudError {
    INTERNAL = 13,
    UNAUTHENTICATED = 16,
    PERMISSION_DENIED = 7,
    INVALID_ARGUMENT = 3,
    FAILED_PRECONDITION = 9,
    NOT_FOUND = 5,
    UNKNOWN = 2,
}
